import { render, staticRenderFns } from "./ProductsSearchBar.vue?vue&type=template&id=1339c019&scoped=true&"
import script from "./ProductsSearchBar.vue?vue&type=script&lang=js&"
export * from "./ProductsSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSearchBar.vue?vue&type=style&index=0&id=1339c019&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339c019",
  null
  
)

export default component.exports